import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const ASSOCIATIONS_REQUEST = 'FETCH_ASSOCIATIONS_REQUEST';
export const ASSOCIATIONS_FAILURE = 'FETCH_ASSOCIATIONS_FAILURE';
export const ASSOCIATIONS_SUCCESS = 'FETCH_ASSOCIATIONS_SUCCESS';

export const fetchAssociations = () => {
    return function(dispatch) {
        dispatch(fetchRequest());
        return axios(apiRequestOptions(apiPath.ASSOCIATIONS.LIST))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(fetchSuccess(response.data))
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => {
    return { type: ASSOCIATIONS_REQUEST }
};

const fetchFailure = (error) => {
    return { type: ASSOCIATIONS_FAILURE, error }
};

const fetchSuccess = (data) => {
    return { type: ASSOCIATIONS_SUCCESS, data }
};